<template>
  <!-- Root element defaults to <nav> but you can override via `tag` -->
  <component
    :is="tag"
    v-bind="$attrs"
    :class="classes"
    role="navigation"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "BaseNavbar",
  inheritAttrs: false,
  props: {
    /** HTML tag to use (nav, header, div…) */
    tag: {
      type: String,
      default: "nav",
    },
    /**
     * Breakpoint to expand at, e.g. 'sm'|'md'|'lg'|'xl',
     * or `false` for never expandable, `true` for always expanded
     */
    toggleable: {
      type: [Boolean, String],
      default: "lg",
    },

    /** 'top' or 'bottom' to fix navbar */
    fixed: {
      type: String,
      default: "top",
      validator: (v) => ["top", "bottom"].includes(v),
    },
    /** 'top' to make navbar sticky-top */
    sticky: {
      type: String,
      default: "top",
      validator: (v) => v === "top",
    },
  },
  computed: {
    classes() {
      const cls = ["navbar"];
      // toggleable / expand
      if (this.toggleable === false) {
        // no expand class
      } else if (this.toggleable === true) {
        cls.push("navbar-expand");
      } else {
        cls.push(`navbar-expand-${this.toggleable}`);
      }
      // fixed
      if (this.fixed) {
        cls.push(`fixed-${this.fixed}`);
      }
      // sticky
      if (this.sticky) {
        cls.push(`sticky-${this.sticky}`);
      }
      return cls;
    },
  },
};
</script>
